import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Text } from 'rebass'

import styled from 'styled-components'

import Logo from '../../assets/svg/logo.svg'
import LogoDark from '../../assets/svg/logo_white.svg'
import Fold from '../../assets/svg/fold.svg'
import Unfold from '../../assets/svg/unfold.svg'
import Wordmark from '../../assets/svg/wordmark.svg'
import WordmarkDark from '../../assets/svg/wordmark_white.svg'
import { useActiveWeb3React  } from '../../hooks'
import { useDarkModeManager } from '../../state/user/hooks'
import { useETHBalances } from '../../state/wallet/hooks'

import Settings from '../Settings'
// import Menu from '../Menu'

import Row, { RowBetween } from '../Row'
import Web3Status from '../Web3Status'
// import VersionSwitch from './VersionSwitch'

const HeaderFrame = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  background: ${({ theme }) => theme.bsBg36};
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  position: relative;
  z-index: 100;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    // padding: 12px 0 0 0;
    width: calc(100%);
    position: relative;
  `};
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;
`
const HeaderElementLeft = styled(HeaderElement)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    // flex-direction: column;
    align-items: center;
    width: 100%;
  `};
`

const HeaderElementWrap = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    // margin-top: 0.5rem;
  `};
`

const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  margin-left: 40px;

  :hover {
    cursor: pointer;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 10px;
  `};
`

const TitleText = styled(Row)`
  width: fit-content;
  white-space: nowrap;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`

const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme, active }) => (!active ? theme.bg1 : theme.bg3)};
  border-radius: 10px;
  white-space: nowrap;
  width: 100%;

  :focus {
    border: 1px solid blue;
  }
`

const NavWrapper = styled.div`
  position: relative;

  .link__hidden {
    opacity: 0;
    overflow: hidden;
    height: 0;
  }
`

const TestnetWrapper = styled.div`
  width: 185px;
  height: 34px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #FDF3E8;
  cursor: pointer;
  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  svg {
    margin-left: 7px;
  }
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    height: 37px;
    font-size: 14px;
  `};
  ${({ theme }) => theme.mediaWidth.upToInfoLarge`
    height: 34px;
    font-size: 12px;
  `};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 54px;
    height: 32px;
    border-radius: 10px;
    svg {
      margin-left: 0;
    }
  `};
`

const NetworkCard = styled.div`
  font-family: 'Baloo Da';
  color: #F2841E;
  font-size: 14px;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    font-size: 13px;
  `};
  ${({ theme }) => theme.mediaWidth.upToInfoLarge`
    font-size: 12px;
  `};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

const NetWorkTitle = styled.div`
  color: #C58560;
  font-size: 14px;
  font-weight: 500;
  padding: 16px 0 16px 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(214, 164, 133, 1);
  font-family: 'Roboto-Medium';
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 16px 0 16px 16px;
  `};
`

const LinksWrapper = styled.div`
  position: absolute;
  top: 50px;
  right: -48px;
  background: #FFFDFA;
  border-radius: 4px;
  width: 247px;
  height: 232px;
  display: flex;
  flex-direction: column;
  z-index: 0;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.16);
  a {
    height: 24px;
    padding-left: 24px;
    margin-bottom: 32px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    top: 45px;
    right: -130px;
    width: 208px;
    height: 197px;
    a {
      height: 18px;
      padding-left: 16px;
      margin-bottom: 24px;
    }
  `};
`

const NavLink = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  grid-column-gap: 15px;
  img {
    width: 24px;
    height: 24px;
  }
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    img {
      width: 18px;
      height: 18px;
    }
  `};
`

const NavText = styled.div`
  color: #722F0D;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Roboto-Medium';
  display: flex;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    font-size: 14px;
  `};
`

// const ComingSoon = styled.div`
//   width: 86px;
//   height: 20px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 4px;
//   background: #FDF3E8;
//   color: #AC552A;
//   font-size: 12px;
//   font-weight: 500;
//   font-family: 'Roboto-Medium';
//   margin-left: 10px;
//   ${({ theme }) => theme.mediaWidth.upToBigerLarge`
//     margin-left: 8px;
//     font-size: 11px;
//   `};
// `

const FoldIcon = styled.div`
  transition: transform 0.3s ease;
  cursor:pointer;
  margin-left: 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    img { 
      // width: 4.5rem;
    }
  `};
`

const UniIcon = styled.div`
  transition: transform 0.3s ease;
  cursor:pointer;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    img { 
      // width: 4.5rem;
    }
  `};
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    // flex-direction: column;
    align-items: center;
    align-self: center;
  `};
`

const BalanceText = styled(Text)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`

const HeaderRowBetween = styled(RowBetween)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    // flex-direction: column;
  `};
`


const links = [
  {
    name: 'BNB Smart Chain',
    testHref: 'https://bsc.bakeryswap.io',
    prodHref: 'https://bsc.bakeryswap.org',
    icon: '/images/bsc.png'
  }, {
    name: 'Base',
    testHref: 'https://base.bakeryswap.io',
    prodHref: 'https://base.bakeryswap.org',
    icon: '/images/base.png'
  }, {
    name: 'Ethereum',
    testHref: 'https://www.bakeryswap.io',
    prodHref: 'https://www.bakeryswap.org',
    icon: '/images/eth.png'
  }
]

export default function Header({ triggerFold, isFold }: {triggerFold: (fold: boolean) => void,isFold: boolean}) {
  const { account } = useActiveWeb3React()
  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']
  const [isDark] = useDarkModeManager()


  const [isTest, setIsTest] = useState(false)

  const [isViewLink, setIsViewLink] = useState(false)
  const [choose, setChoose] = useState({
    name: 'BNB Smart Chain',
    testHref: 'https://bsc.bakeryswap.io',
    prodHref: 'https://bsc.bakeryswap.org',
    icon: '/images/bsc.png'
  })
  const handleChooseNetwork = useCallback((item) => {
    if (item.isDisabled) return
    setChoose(item)
  }, [])

  useEffect(() => {
    window.location.href.indexOf('base.bakeryswap.io') > -1 && setIsTest(true)
  }, [])

  const handleSwitch = useCallback(() => {
    setIsViewLink(!isViewLink)
  }, [isViewLink])

  const containerContactEl: any = useRef(null)
  const checkForOuterAction = (event: any) => {
    if (!containerContactEl.current || !event.target.className.indexOf) return
    const isOuterAction =
      !containerContactEl.current.contains(event.target) &&
      (event.target.className.indexOf('switch') < 0)
    if (isOuterAction) {
      setIsViewLink(false)
    }
  }

  useEffect(() => {
    window.addEventListener('mousedown', checkForOuterAction)
    return () => {
      window.removeEventListener('mousedown', checkForOuterAction)
    }
  }, [])

  return (
    <HeaderFrame id="header_id">
      <HeaderRowBetween style={{ alignItems: 'center' }} padding="0.5rem">
        <HeaderElementLeft>
          <FoldIcon>
            <img src={isFold ? Fold : Unfold} style={{ height: 28 }} onClick={triggerFold.bind(null, !isFold)} alt="" />
          </FoldIcon>
          <Title href=".">
            <UniIcon>
              <img src={isDark ? LogoDark : Logo} style={{ height: 32 }} alt="logo" />
            </UniIcon>
            <TitleText>
              <img
                style={{ marginLeft: '5px', marginTop: '0px', height: 20 }}
                src={isDark ? WordmarkDark : Wordmark}
                alt="logo"
              />
            </TitleText>
          </Title>
        </HeaderElementLeft>
        <HeaderControls>
          <HeaderElement>
            <NavWrapper>
              <TestnetWrapper className="switch" onClick={() => handleSwitch()}>
                <img src={choose.icon} className="switch" />
                <NetworkCard className='switch'>{choose.name}</NetworkCard>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="switch" style={{ transform: !isViewLink ? 'rotate(180deg)' : '' }}>
                  <path d="M7.66666 5.20403L4.41737 9.14679C4.34959 9.22902 4.30659 9.32883 4.29339 9.43458C4.28019 9.54032 4.29733 9.64764 4.34281 9.74402C4.38828 9.84039 4.46023 9.92185 4.55024 9.97889C4.64026 10.0359 4.74464 10.0662 4.8512 10.0662H11.4375C11.5447 10.0662 11.6497 10.0356 11.74 9.97799C11.8304 9.92034 11.9024 9.83803 11.9476 9.74079C11.9927 9.64355 12.0091 9.53543 11.9948 9.42918C11.9805 9.32294 11.9361 9.223 11.8668 9.14117L8.52872 5.19841C8.47556 5.1357 8.4093 5.08542 8.3346 5.05111C8.2599 5.0168 8.17858 4.99929 8.09637 4.99983C8.01417 5.00036 7.93309 5.01893 7.85884 5.05421C7.78459 5.08949 7.71899 5.14063 7.66666 5.20403Z" fill="#C58561"/>
                </svg>
              </TestnetWrapper>
              <LinksWrapper ref={containerContactEl} className={!isViewLink ? 'link__hidden' : ''}>
                <NetWorkTitle>Select a Network</NetWorkTitle>
                {links.map((d, index) => {
                  return (
                    <NavLink href={isTest ? d.testHref : d.prodHref} key={index} onClick={() => handleChooseNetwork(d)}>
                      <img src={d.icon} />
                      <NavText style={{ color: choose.name === d.name ? '#F2841E' : '#722F0D' }}>
                        {d.name}
                      </NavText>
                    </NavLink>
                  )
                })}
              </LinksWrapper>
            </NavWrapper>
            <AccountElement active={!!account} style={{ pointerEvents: 'auto' }}>
              {account && userEthBalance ? (
                <BalanceText style={{ flexShrink: 0 }} pl="0.75rem" pr="0.5rem" fontWeight={500}>
                  {userEthBalance?.toSignificant(4)} BNB
                </BalanceText>
              ) : null}
              <Web3Status />
            </AccountElement>
          </HeaderElement>
          <HeaderElementWrap>
            <Settings />
          </HeaderElementWrap>
        </HeaderControls>
      </HeaderRowBetween>
    </HeaderFrame>
  )
}
